import {
  put,
  fork,
  takeLatest
} from 'redux-saga/effects';
import {NORMALIZE_DATA} from '../../dataProvider/dataProvider';
import {SET_DATA} from '../plan/plan';
import {setConsumerType} from '../../common/common';

// WATCHERS
export function* normalizeWatch() {
  yield takeLatest(NORMALIZE_DATA, normalizeWorker);
}

// WORKERS
export function* normalizeWorker({key, data}) {
  if (key !== 'context') {
    return;
	}

  yield put(setConsumerType(data.consumerType));
  yield put({type: SET_DATA, payload: {
    isPlanAvailable: data.isPlanAvailable !== false
  }});
}

export default function* contextSagas() {
  yield [
    fork(normalizeWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/context/contextSagas.js
 **/